<app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal"></app-page-breadcrumb>
<div class="modal-body pt-2 mb-4" (keyup.enter)="saveData()">
    <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <div class="card w-75 ">
            <app-form-generator #basicForm (onChangeEvent)="onChange($event)" [formData]="userFormData">
            </app-form-generator>
            <div class=" align-center text-center mt-1 " style="max-width: 100%;">
                <button type="button" (click)="close()" [disabled]="loading"
                    class="btn btn-round btn-danger mr-2 pull-left">Close</button>
                <button type="button" (click)="saveData()" [disabled]="loading"
                    class="btn btn-round btn-success mr-2 pull-left">Save</button>
            </div>
        </div>
    </div>
</div>